import script from "./Pollutants.vue?vue&type=script&setup=true&lang=js"
export * from "./Pollutants.vue?vue&type=script&setup=true&lang=js"

import "./Pollutants.vue?vue&type=style&index=0&id=73064260&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73064260"]])

export default __exports__